import { O, pipe } from '@mobily/ts-belt';
import { usePropertyContext } from 'app/properties/components/SingleProperty';
import { useQuery } from 'react-query';

import { GetPropertyConnectionResponse } from 'app/connection/api';
import * as TE from 'common/TaskEither';
import { getPropertyConnections } from '../api/getPropertyConnections';

export const propertyConnectionKey = (propertyId?: number | null) => ['propertyConnection', propertyId] as const;

export const fetchPropertyConnection = (propertyId?: number | null) => () =>
  pipe(propertyId, O.map(getPropertyConnections), O.getExn);

export const useGetPropertyConnections = (): TE.ITaskEither<string, GetPropertyConnectionResponse> => {
  const { id: propertyId } = usePropertyContext();

  const query = useQuery(propertyConnectionKey(propertyId), fetchPropertyConnection(propertyId), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  switch (query.status) {
    case 'error':
      return TE.Error(JSON.stringify(query.error));
    case 'success':
      return TE.Ok(query.data);
    default:
      return TE.Loading;
  }
};
